export default __webpack_public_path__ + "static/media/Logo.022c517c.svg";